import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app-config.loader';
import { Qualifica } from '../shared/models/qualifica.model';
import { AnagraficaBaseService } from './anagrafica-base.service';

@Injectable({
  providedIn: 'root'
})
export class AnagraficaQualificheService extends AnagraficaBaseService<Qualifica> {
  constructor(appConfig: AppConfig, http: HttpClient) {
    super(http, `${appConfig.settings.apiRoot}/AnagraficaQualifiche`);
  }

  readonly idProperty = 'qualificaId';
  readonly nameProperty = 'nomeQualifica';
}
